import styled from 'styled-components';

export const StyledHelpButtonContent = styled.span`
    font-size: ${props => props.theme.global.fontSizes.visible};
    font-weight: ${props => props.theme.global.fontWeights.regular};
`;
